export default "__VITE_ASSET__BEqwjm9y__"